import { Component, inject } from "@angular/core";
import { AsyncPipe } from "@angular/common";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { RouterLoadingService } from "../../services/router-loading.service";
import { LoadingService } from "../../services/loading.service";
import { combineLatest, map } from "rxjs";

@Component({
	selector: "app-loading-overlay",
	standalone: true,
	imports: [AsyncPipe, MatProgressSpinnerModule],
	templateUrl: "./loading-overlay.component.html",
	styleUrls: ["./loading-overlay.component.scss"],
})
export class LoadingOverlayComponent {
	private routerLoadingService = inject(RouterLoadingService);
	private loadingService = inject(LoadingService);

	// Combine both route loading and general loading states
	loadingState$ = combineLatest([
		this.routerLoadingService.routeLoading$,
		this.loadingService.loading$,
		this.loadingService.message$,
		this.loadingService.hint$,
	]).pipe(
		map(([routeContext, generalLoading, generalMessage, generalHint]) => {
			if (routeContext.isLoading) {
				return {
					isLoading: true,
					message: routeContext.message || "Loading...",
					hint: undefined as string | undefined,
					type: "route",
				};
			} else if (generalLoading) {
				return {
					isLoading: true,
					message: generalMessage || "Loading...",
					hint: generalHint,
					type: "general",
				};
			}
			return {
				isLoading: false,
				message: "",
				hint: undefined as string | undefined,
				type: "general",
			};
		}),
	);
}
